import request from '../untils/request';

export const appointmentList = params => {
  return request({
    url: '/appointment/appointment/appointment-list',
    params,
  });
};

export const appointmentReviewList = params => {
  return request({
    url: '/appointment/appointment/review-list',
    params,
  });
};

export const appointmentApproval = params => {
  return request({
    url: '/appointment/appointment/approval',
    params,
  });
};

export const appointmentBatchApproval = params => {
  return request({
    url: '/appointment/appointment/batch-approval',
    params,
  });
};

export const appointmentGroupList = params => {
  return request({
    url: '/appointment/appointment/get-group-list',
    params,
  });
};

export const appointmentAddressList = params => {
  return request({
    url: '/appointment/appointment/address-list',
    params,
  });
};

export const appointmentAddressDetail = params => {
  return request({
    url: '/appointment/appointment/address-detail',
    params,
  });
};

export const appointmentAddressAdding = params => {
  return request({
    url: '/appointment/appointment/add-address',
    params,
  });
};

export const appointmentAddressEdit = params => {
  return request({
    url: '/appointment/appointment/modify-address',
    params,
  });
};

export const appointmentGetReject = params => {
  return request({
    url: '/appointment/appointment/get-all-reject',
    params,
  });
};

export const appointmentCreateReject = params => {
  return request({
    url: '/appointment/appointment/add-reject',
    params,
  });
};

export const appointmentEditReject = params => {
  return request({
    url: '/appointment/appointment/modify-reject',
    params,
  });
};

export const appointmentDelReject = params => {
  return request({
    url: '/appointment/appointment/delete-reject',
    params,
  });
};

export const appointmentGroupSetting = params => {
  return request({
    url: '/appointment/appointment/get-group-setting',
    params,
  });
};

export const appointmentGroupSettingEdit = params => {
  return request({
    url: '/appointment/appointment/modify-group-setting',
    params,
  });
};

export const appointmentPersonalSetting = params => {
  return request({
    url: '/appointment/appointment/get-person-setting',
    params,
  });
};

export const appointmentPersonalSettingEdit = params => {
  return request({
    url: '/appointment/appointment/modify-person-setting',
    params,
  });
};

export const appointmentAllAddress = params => {
  return request({
    url: '/appointment/appointment/get-all-address',
    params,
  });
};

export const appointmentRejectList = params => {
  return request({
    url: '/appointment/appointment/get-reject-list',
    params,
  });
};

export const appointmentBatchReject = params => {
  return request({
    url: '/appointment/appointment/batch-reject',
    params,
  });
};

export const appointmentReviewCounts = params => {
  return request({
    url: '/appointment/appointment/review-wait-count',
    params,
  });
};


export const cancelAppointmentApi = params => {
  return request({
    url: '/appointment/appointment/cancel-appointment',
    params,
  });
};


export const batchAppointmentApi = params => {
  return request({
    url: '/appointment/appointment/batch-appointment',
    params,
  });
};
